(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9107],{

/***/ 28400:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/san-pham/hide",
      function () {
        return __webpack_require__(38137);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58262);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29757);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81703);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ProductHideLayout = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-20 md:tw-pt-6 md:tw-pb-14 tw-pb-20 tw-h-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-fixed tw-block md:tw-hidden tw-z-50 tw-top-6 tw-left-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-10 tw-flex tw-items-center tw-justify-center",
                        onClick: function() {
                            return next_router__WEBPACK_IMPORTED_MODULE_2___default().back();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                            className: "tw-w-6 tw-h-6 tw-text-primary-main",
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ArrowLeftIcon */ .Y, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-text-secondary-70",
                    children: "Sản phẩm"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-justify-center tw-flex-col md:tw-flex-row tw-gap-6 lg:tw-gap-10 tw-mt-10 md:tw-mt-20 lg:tw-mt-20 xl:tw-mt-40",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-text-xl tw-text-center md:tw-text-left",
                            children: "Sản phẩm đang được chỉnh sửa vui l\xf2ng chờ mở b\xe1n lại"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                            alt: "hide-product",
                            src: "/hide-product.png",
                            className: "tw-order-first md:tw-order-last tw-w-full tw-h-[250px] md:tw-w-[300px] md:tw-h-[200px] lg:tw-w-[400px] lg:tw-h-[266px]"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductHideLayout);


/***/ }),

/***/ 38137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _features_products_hide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66759);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var ProductHidePage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_products_hide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductHidePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(28400); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);